import { ListItemNode, ListNode } from '@lexical/list'
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table'
import { Klass, LexicalNode } from 'lexical'

import { AttachmentNode } from './AttachmentNode'
import { EmojiNode } from './EmojiNode'
import { FillerNode } from './FillerNode'
import { ImageNode } from './ImageNode'
import { LinkNode } from './LinkNode'
import { TableControllerNode } from './TableControllerNode'
import { TableWrapperNode } from './TableWrapperNode'

export const editorNodes: Array<Klass<LexicalNode>> = [
  HeadingNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  LinkNode,
  ImageNode,
  AttachmentNode,
  TableWrapperNode,
  TableControllerNode,
  TableNode,
  TableRowNode,
  TableCellNode,
  FillerNode,
  EmojiNode,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  HorizontalRuleNode
]
